import { __stringify } from '@nu-art/ts-common';
import { Base_RequestMessageComposer } from '../../Page_BaseSandbox/Base_RequestMessageComposer/index.js';
import { ModuleFE_SandboxFHIR } from '../../modules/ModuleFE_SandboxFHIR/index.js';
export class FHIRSandboxRequestComposer extends Base_RequestMessageComposer {
    static defaultProps = {
        module: ModuleFE_SandboxFHIR
    };
    __onTemplateSelected(template) {
        // Convert template content (FhirSandbox['request'] object) to JSON string if it's an object
        const templateString = template.content && typeof template.content === 'object'
            ? __stringify(template.content, true)
            : undefined;
        this.reDeriveState({
            selectedTemplate: template,
            templateString
        });
    }
    deriveStateFromProps(nextProps, state) {
        // Convert template content (FhirSandbox['request'] object) to JSON string if it's an object
        // This must be done BEFORE calling super, as the base class expects templateString to be a string
        if (state.selectedTemplate?.content && typeof state.selectedTemplate.content === 'object' && !state.templateString) {
            state.templateString = __stringify(state.selectedTemplate.content, true);
        }
        state = super.deriveStateFromProps(nextProps, state);
        return state;
    }
    sendRequest = async () => {
        if (this.state.templateString.length === 0) {
            this.logError('Can\'t send empty FHIR sandbox request');
            return;
        }
        return await ModuleFE_SandboxFHIR.sendRequest(this.state.selectedTemplate, this.state.templateString);
    };
}
//# sourceMappingURL=FHIRSandboxRequestComposer.js.map